// extracted by mini-css-extract-plugin
export default {"container":"ChallengesList_container__aWves","list":"ChallengesList_list__7gMFn"};